export { MemoryKvStore, openIdbKv, type KvStore } from '@merkury/brain/storage/kv.js';
export {
  SecretStore,
  WebCryptoSecretCipher,
  type SecretCipher,
  type WrappedSecret,
} from '@merkury/brain/storage/secretStore.js';
export { AccountStore, type StoredAccount } from '@merkury/brain/storage/accountStore.js';
export {
  clearFavorites,
  getFavorites,
  isFavorite,
  resetFavoritesCache,
  setFavorite,
  subscribeFavorites,
  toggleFavorite,
} from './favorites.js';
export {
  clearAliases,
  getAlias,
  getAliases,
  getAliasSyncMarker,
  onAliasesChanged,
  replaceAliases,
  resetAliasesCache,
  sanitizeAlias,
  setAlias,
  setAliasSyncMarker,
} from './aliases.js';
export {
  clearServerCache,
  getCachedBlocks,
  getCachedFriends,
  getCachedRequests,
  resetServerCacheSnapshots,
  setCachedBlocks,
  setCachedFriends,
  setCachedRequests,
  subscribeServerCache,
  type CachedRequests,
  type CachedSnapshot,
} from './serverCache.js';
export {
  CALL_LOG_CAP,
  clearCallLog,
  getCallLog,
  markAllMissedSeen,
  recordEndedCall,
  resetCallLogCache,
  StoredCallLogEntry,
  subscribeCallLog,
} from './callLog.js';

import { clearFavorites } from './favorites.js';
import { clearAliases } from './aliases.js';
import { clearServerCache } from './serverCache.js';
import { clearCallLog } from './callLog.js';

/**
 * Everything account-scoped that lives outside the kv/SecretStore wipe: the
 * server-list cache, favorites, contact aliases, and the local call log.
 * Sign-out calls this so the previous account's contacts and history never
 * survive on disk.
 */
export function clearLocalAccountData(): void {
  clearServerCache();
  clearFavorites();
  clearAliases();
  clearCallLog();
}
